import { Button } from "@primitives/button";
import { useNewGroupChatState } from "@/zustand/NewGroupChatState";
import { ChevronRight } from "lucide-react";

import { useTranslation } from "react-i18next";

export default function SecondStepButton() {
  const { t } = useTranslation();

  // state values
  const usernames = useNewGroupChatState((state) => state.usernames);
  // state actions
  const setStep = useNewGroupChatState((state) => state.setStep);

  if (usernames.length < 1) {
    return null;
  }

  return (
    <Button
      onClick={() => setStep(2)}
      className="ml-auto px-0 text-base leading-tight text-secondary no-underline hover:no-underline"
      variant="link"
    >
      {t("next")}
      <ChevronRight />
    </Button>
  );
}
